<div class="header">
  <div class="title">
    <div class="title-text">Laser</div>
  </div>
  <span class="message">* populated from PatientNow</span>
</div>
<hr class="divider" />
@for (record of records(); track record) {
  <fb-laser-treatment-control-display
    [value]="record.item"
    [labels]="record.labels"
    [markerTarget]="record.markerTarget"
    [rowIndex]="$index"
    [muted]="isEmrReadonly()"
  />
  <hr class="divider" />
}
@if (isEmrReadonly()) {
  <fb-emr-readonly-notice />
} @else {
  <div class="action">
    <rx-icon name="icon-circle-plus-2" class="action-icon" />
    <span class="action-label">Add Laser</span>
  </div>
}
